<script>

    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import Modal from '../$components/modal.container.svelte'

    import AccountsAllComponent from './component.accounts.svelte'
    import AccountComponent from './component.account.svelte'
    import AccountUpdateComponent from './component.update.svelte'

    if(!isPermission($adminStore, 'UsersView.Accounts.View'))
        replace('/404')

</script>

<View>
    <PageHeader title="Cuentas" subtitle="Estados de cuenta y cortes de usuarios" />
    <AccountsAllComponent all={true} />
</View>

<Modal id="account_modal" title="Cuenta" >
    <AccountComponent />
</Modal>

<Modal id="account_update_modal" title="Cuenta" >
    <AccountUpdateComponent />
</Modal>
